import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * 监听所有 .reveal 元素，进入视口时加 .is-visible 触发动画。
 * 路由切换时重新扫描，保证新页面的元素也能触发。
 */
export default function useReveal() {
  const { pathname } = useLocation();

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );

    const scan = () => {
      document.querySelectorAll('.reveal:not(.is-visible)').forEach((el) => {
        observer.observe(el);
      });
    };

    // 等新页面渲染完成后扫描
    const t1 = setTimeout(scan, 50);
    const t2 = setTimeout(scan, 450);

    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      observer.disconnect();
    };
  }, [pathname]);
}